import { useMemo } from 'react';
import { map } from 'lodash';

import { useCurrentWorkspace } from './useCurrentWorkspace';

export const useWorkspaceAssociatedProjectIds = () => {
  const currentWorkspace = useCurrentWorkspace();
  return useMemo(
    () => map(currentWorkspace?.associatedProjects, 'id').join(','),
    [currentWorkspace]
  );
};
